// from 'dd-mm-yyyy hh:mm:ss - dd-mm-yyyy hh:mm:ss'
// to 'dd MMM yy hh:mm - dd MMM yy hh:mm'
const formatPromoPeriod = (promoPeriod) => {
  if (!promoPeriod) return '';

  const formatRegex = /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2} - \d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/;
  if (!formatRegex.test(promoPeriod)) {
    return '';
  }

  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const [startDateStr, endDateStr] = promoPeriod.split(' - ');

  const formatDate = (dateStr) => {
    const [datePart, timePart] = dateStr.split(' ');
    const [day, month, year] = datePart.split('-');
    const [hour, minute] = timePart.split(':');

    const monthName = monthNames[parseInt(month, 10) - 1];
    const shortYear = year.slice(-2);

    return `${day} ${monthName} ${shortYear} ${hour}:${minute}`;
  };

  return `${formatDate(startDateStr)} - ${formatDate(endDateStr)}`;
};

export default formatPromoPeriod;
